import { styled } from 'styled-components';

import { WRAPPER } from '@/shared/styles/themes';

const RootContainer = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: #131315;
  width: 100%;
  @media (min-width: 768px) {
    padding: 30px 0;
    margin-bottom: 60px;
  }
`;

const BannerContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 50px;
  justify-content: center;
  align-items: center;
`;
const BannerVideo = styled.video`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const BannerNotAuth = styled.img`
  width: 100%;
  overflow: hidden;
  border-radius: 12px;

  @media (min-width: 768px) {
    height: 220px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: min(1132px, 100%);
  padding: 24px 0;
  gap: 24px;
`;
const ScrollContent = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: stretch;
  justify-items: center;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 768px) {
    overflow: auto;
    justify-content: center;
  }
`;
const StatusList = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 18px;
  padding-left: 18px;
  padding-right: 18px;

  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 768px) {
    justify-items: center;
    gap: 24px;
    padding: 0;
  }
`;

const InfoContainer = styled.div`
  color: #fff;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  width: 100%;
  padding-left: 18px;
  padding-right: 18px;

  @media (min-width: 768px) {
    flex-grow: 1;
    padding: 12px;
    width: 100%;
    min-width: 45%;
    max-width: 72%;
    text-align: center;
  }
`;
const HintAndInfoDesktop = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  padding: 30px 0;
  justify-content: center;
  @media (max-width: 768px) {
    padding-left: 18px;
    padding-right: 18px;
  }
`;

const SignButtonGreen = styled.div`
  display: flex;
  height: 48px;
  padding: 0px 28px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 8px;
  background: linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%);
`;
const SignButtonBlue = styled.div`
  display: flex;
  height: 48px;
  min-width: 120px;
  padding: 0px 28px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #625a63;
`;
const SignButtonWrapper = styled.div`
  display: flex;
  padding: 24px 12px;
  align-items: center;
  gap: 12px;
  width: 100%;
  @media (min-width: 769px) {
    display: none;
  }
`;

const ProgressBarLabel = styled.div`
  color: #fff;
  text-align: center;
  font-family: Rubik;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  position: relative;
  z-index: 1;
  @media (min-width: 769px) {
    font-size: 14px;
  }
`;
const ProgressBar = styled.div`
  width: 120px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 12px;
  border:
    1px solid linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%),
    linear-gradient(126deg, #5bdbff 1.05%, rgba(91, 219, 255, 0) 46.67%),
    #2672ff;
  background: #27262b;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => props.$progress}%;
    border-radius: 12px;
    background:
      linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%),
      linear-gradient(126deg, #5bdbff 1.05%, rgba(91, 219, 255, 0) 46.67%),
      #2672ff;
    border-radius: 12px;
  }

  @media (min-width: 768px) {
    width: 178px;
    height: 18px;
  }
`;
const Wrapper = styled.div`
  ${WRAPPER};
  display: flex;
  margin: 0;
  flex-direction: column;
  align-items: center;
  align-content: center;
  max-width: min(100%, 1132px);
  @media (max-width: 768px) {
    margin-top: 0;
    max-width: 100%;
    width: 100%;
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  width: min(100%, 1132px);
  flex-direction: column;
  align-items: center;
  align-content: center;
`;

export {
  RootContainer,
  BannerContainer,
  BannerVideo,
  BannerNotAuth,
  Content,
  ScrollContent,
  StatusList,
  InfoContainer,
  HintAndInfoDesktop,
  SignButtonGreen,
  SignButtonBlue,
  SignButtonWrapper,
  ProgressBarLabel,
  ProgressBar,
  Wrapper,
  ContentWrapper,
};
